import React, {Component} from 'react';
// import {Redirect} from 'react-router';
// import ReactDOM from 'react-dom';
import Settings from '../lib/settings';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import * as Actions from '../actions';
var ObjectId = require("bson-objectid");


class Orders extends Component {

  constructor(props) {
    super(props);
    this.state = {
      orders: []
    };
    this.loadOrders();
    window.scrollTo(0, this.props.menuPosition);
  }

  componentDidMount() {
    this.loadOrders();
  }

  handleImageLoaded(event) {
    event.target.classList.remove("imageLoading");
  }

  loadOrders() {

    //this.props.dispatch(Actions.loader(true));
    fetch('/api/orders/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {
      //this.props.dispatch(Actions.loader(false));
      if (typeof json !== "undefined" && json !== []) {
        this.setState({empty: false, orders: json});
      } else {
        this.setState({empty: true});
      }
    });

  }

  componentWillReceiveProps(nextProps) {
    this.loadOrders();
  }

  handleChange(event) {

    this.setState({
      [event.target.name]: event.target.value
    });

    if (event.target.name === "selectedShipping") {
      this.setState({selectedPayment: "default"});
    }

  }

  handleStatusChange(event, id, index) {

    let order = {
      _id: id,
      status: event.target.value
    }

    fetch("/api/orders/changestatus", Settings.fetchParams('POST', order)).then(res => {
      if (res.ok) {
        res.json().then(json => {

          if (!json.error && json) {

            let ordersTemp = this.state.orders;
            ordersTemp[index] = json;

            this.setState({
              orders: ordersTemp
            });

          } else {
            alert("Chyba při změně statusu");
          }
        })
      } else {
        alert("Chyba2 při změně statusu");
      }
    });

  }

  deleteOrder(id) {
    let canDelete = window.confirm("Opravdu chcete smazat objednávku? Tento proces NELZE vrátit!");
    let canDelete2 = false;
    if(canDelete) {
      canDelete2 = window.confirm("Potvrzuji, že kompletně mažu objednávku z databáze.");
    }

    if (canDelete && canDelete2) {
    //this.props.dispatch(Actions.loader(true));
    fetch("/api/orders/" + id, Settings.fetchParams('DELETE')).then(res => {
      this.props.dispatch(Actions.loader(false));
      if (res.ok) {
        res.json().then(json => {
          if (!json.error && json.deleted) {

            this.loadOrders();

          } else {
            alert("Error");
          }
        })
      } else {
        alert("Error");
      }
    });
  }
  }

  render() {


    //console.log(this.state.orders);

    const statusSwitch = (param) => {
      switch(param) {
        case 'pending':
          return 'Čeká';
        case 'inProcess':
          return 'Vyřizuje se';
        case 'payed':
          return 'Zaplacena';
        case 'shipped':
          return 'Odeslána';
        case 'cancelled':
          return 'Stornována';
        default:
          return '-';
      }
    }

    const orderItems = this.state.orders.map((item, index) => {

      let orderDate = ObjectId(item._id).getTimestamp();
      return (<div key={index} className="orderItem">

        <div className="ordersDescriptionWrapper">
          <div className="ordersId">
            <Link to={"/order/" + item._id}><span>Číslo objednávky: </span>{item.orderNumber}</Link>
          </div>
          <div className="">
            <Link to={"/order/" + item._id}><span>Datum: </span>{orderDate.getDate() + "." + (orderDate.getMonth() + 1) + " " + orderDate.getFullYear()}
            </Link>
          </div>
          <div className="">
            <span>Stav: </span>
            {
              this.props.admin
              ? <select value={item.status} onChange={(e) => {
                  this.handleStatusChange(e, item._id, index)
                }}>

                <option value="pending">Čeká</option>
                <option value="inProcess">Vyřizuje se</option>
                <option value="payed">Zaplacena</option>
                <option value="shipped">Odeslána</option>
                <option value="ready">Připravena k vyzvednutí</option>
                <option value="cancelled">Stornována</option>
              </select>
              :
              <span className="orderStatusSpan">
              {statusSwitch(item.status)}</span>

            }

          </div>
          <div className=""><span>Uživatel: </span>{item.user.name + " " + item.user.surname}
          </div>
          <div className=""><span>Cena celkem: </span>{parseFloat(item.total).toLocaleString()}
            Kč
          </div>
        </div>
        <div className="itemRemove">
          {
            this.props.admin
          ? <i className="fas fa-trash-alt" onClick={() => {
              this.deleteOrder(item._id)
            }}></i>
          : <span>&nbsp;</span>

          }
        </div>
      </div>)
    });

    return this.state.orders.length < 1
      ? (<div className="emptyCart">
        <div>
          <h2>Žádné objednávky</h2>
        </div>
      </div>)
      : (<div ref="cart">
        <div className="productDetails">
          <div className="col100">
            <div className="articleWrapper">
              <h2>Objednávky</h2>
              <div className="cartItemsWrapper">
                <div className="ordersItemsHeading">
                  <div className="ordersDescriptionWrapper">
                    <div className="">Číslo objednávky</div>
                    <div className="">Datum</div>
                    <div className="">Stav</div>
                    <div className="">Uživatel</div>
                    <div className="">Cena celkem</div>

                  </div>
                  {
                    this.props.admin
                  ? <div className="itemRemove">X</div>
                  : <span>&nbsp;</span>

                  }

                </div>
                {orderItems}

              </div>

            </div>
          </div>
        </div>
      </div>);
  }
}
function mapStateToProps(state) {
  return {admin: state.admin, user: state.user, menuPosition: state.menuPosition, cart: state.cart};
}
export default connect(mapStateToProps)(Orders);



// WEBPACK FOOTER //
// ./src/pages/Orders.js